import Head from 'next/head'
import SectionTitle from "@/components/sectionTitle";
import Link from "next/link";
import React from "react";
import configData from '@/components/utils/configData'
import bodyFont from "@/components/bodyFont";

export default function Home() {
    return (
        <main className="relative">
            <Head>
                <title>Hairstyliste Lisa | Prijslijst</title>
            </Head>
            <div className="bg-black py-20 text-gold px-5">

                <div className="flex w-full flex-col justify-center items-center">

                    <div>
                        <SectionTitle>Prijzen</SectionTitle>
                    </div>
                    <div className={`${bodyFont.className} flex flex-col max-w-lg text-copy`}>
                        <div className="text-gold flex mb-10 justify-start max-w-3xl">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                 stroke="currentColor" className="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5"/>
                            </svg>
                            <Link href="/">Terug</Link>

                        </div>
                        {configData.prices.map(price => (
                            <div className={`${price.padding ? 'mt-6' : '' } leading-tight mb-1`} key={price.title}>
                                {price.title !== null && <span className="font-bold">{price.title}</span>}
                                <div className="font-thin flex justify-between items-end">
                                    <div className="max-w-[70%]">
                                    {price.features.join(' - ')}
                                    </div>
                                    <span>{price.prefix !== undefined && <span className="mr-10">{price.prefix}</span>} {price.hideEuro !== true && <span>&euro;</span>}{price.price}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </main>
    )
}
